/*
 * WebCRD
 * Web to print solution that automates ordering, fulfillment, job ticketing, production management and chargebacks across corporate print centers.
 * Copyright 1999-2026 Rochester Software Associates (service@rocsoft.com)
 */

import api from './api';

const path = 'cart';

export const get = async () => {
    return api.get(path);
};

export const setID = async (id) => {
    return api.patch(path, { id });
};

export const upload = async ({ files, paperSelectionFilter, jobTicketTemplate, printOptions = [], printOptionProfileID = 0 }) => {
    return api.post(`${path}/upload`, { files, paperSelectionFilter, jobTicketTemplate, printOptions, printOptionProfileID }, { isMultiPart: true });
};

export const specialOrder = async () => {
    return api.post(`${path}/specialOrder`);
};

export const addItemFromCatalog = async (item, quantity, isBackorderConfirmed, printOptions = []) => {
    return api.post(`${path}/addItemFromCatalog`, { itemID: item.id, quantity, printOptions, isBackorderConfirmed });
};

export const addRecipient = async (addressID, shipMethodID, shipperAccountNumber, instructions, quantities) => {
    return api.post(`${path}/addRecipient`, { addressID, shipMethodID, shipperAccountNumber, instructions, quantities });
};

export const addDistributionList = async (listID, shipMethodID, shipperAccountNumber, instructions) => {
    return api.post(`${path}/addDistributionList`, { listID, shipMethodID, shipperAccountNumber, instructions });
};

export const splitAccountCodeType = async (accountCodeTypeID) => {
    return api.post(`${path}/splitAccountCodeType`, { accountCodeTypeID: accountCodeTypeID });
};

export const submitOrder = async (ignoreOptionalChanges) => {
    return api.post(`${path}/submitOrder`, { ignoreOptionalChanges });
};

export const cancelPayment = async (cancelPaymentID, orderID) => {
    return api.post(`${path}/cancelPayment`, { cancelPaymentID, orderID });
};

// used to change current cart to saved
export const save = async () => {
    return api.post(`${path}/save`);
};
